import type { ApolloCache } from "@apollo/client/cache"

import {
  TeamMemberFragment,
  TeamMemberFragmentDoc
} from "../graphql/fragments.generated"
import { TeamMemberTypename } from "../types/TeamMember"

export function readTeamMember(id: string, cache: ApolloCache<object>) {
  const cacheId = cache.identify({ id, __typename: TeamMemberTypename })
  if (!cacheId) return null
  return cache.readFragment<TeamMemberFragment>(
    {
      id: cacheId,
      fragmentName: "TeamMember",
      fragment: TeamMemberFragmentDoc
    },
    true
  )
}
